import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { ref, set, onValue } from 'firebase/database';

export default function DarkModeToggle() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // مراقبة حالة الوضع الليلي من Firebase
    const darkModeRef = ref(db, 'darkMode');
    const unsubscribe = onValue(darkModeRef, (snapshot) => {
      if (snapshot.exists()) {
        const darkMode = snapshot.val();
        setIsDarkMode(darkMode);
        applyDarkMode(darkMode);
      }
    });

    return () => unsubscribe();
  }, []);

  const applyDarkMode = (darkMode) => {
    // تطبيق الوضع الليلي فقط على لوحة التحكم
    const adminPanel = document.querySelector('[data-admin-panel]');
    if (!adminPanel) return;

    if (darkMode) {
      // تطبيق متغيرات الألوان على العنصر الرئيسي
      adminPanel.style.setProperty('--bg-primary', '#1a1a1a');
      adminPanel.style.setProperty('--bg-secondary', '#2d2d2d');
      adminPanel.style.setProperty('--bg-card', '#333333');
      adminPanel.style.setProperty('--text-primary', '#ffffff');
      adminPanel.style.setProperty('--text-secondary', '#cccccc');
      adminPanel.style.setProperty('--border-color', '#444444');
      adminPanel.style.setProperty('--shadow-color', 'rgba(0, 0, 0, 0.3)');
      adminPanel.style.setProperty('--header-bg', 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)');
      adminPanel.style.setProperty('--button-bg', '#4a4a4a');
      adminPanel.style.setProperty('--button-hover', '#5a5a5a');
      adminPanel.style.setProperty('--success-color', '#28a745');
      adminPanel.style.setProperty('--warning-color', '#ffc107');
      adminPanel.style.setProperty('--danger-color', '#dc3545');
      adminPanel.style.setProperty('--info-color', '#17a2b8');
      adminPanel.classList.add('dark-mode');

      // تطبيق الألوان مباشرة على العناصر المحددة
      const elements = adminPanel.querySelectorAll('*');
      elements.forEach(element => {
        const style = element.style;
        
        // تطبيق على البطاقات
        if (style.background === '#fff' || style.background === '#ffffff') {
          style.background = '#333333';
        }
        
        // تطبيق على النصوص
        if (style.color === '#263159' || style.color === '#333' || style.color === '#333333') {
          style.color = '#ffffff';
        }
        
        if (style.color === '#666' || style.color === '#888') {
          style.color = '#cccccc';
        }
        
        // تطبيق على الحدود
        if (style.border && (style.border.includes('#ddd') || style.border.includes('#e0e0e0'))) {
          style.border = style.border.replace(/#ddd|#e0e0e0/g, '#444444');
        }
        
        // تطبيق على الظلال
        if (style.boxShadow && style.boxShadow.includes('rgba(0,0,0,0.1)')) {
          style.boxShadow = style.boxShadow.replace('rgba(0,0,0,0.1)', 'rgba(0, 0, 0, 0.3)');
        }
      });
    } else {
      // تطبيق متغيرات الألوان على العنصر الرئيسي
      adminPanel.style.setProperty('--bg-primary', '#f6f8fa');
      adminPanel.style.setProperty('--bg-secondary', '#ffffff');
      adminPanel.style.setProperty('--bg-card', '#ffffff');
      adminPanel.style.setProperty('--text-primary', '#263159');
      adminPanel.style.setProperty('--text-secondary', '#495057');
      adminPanel.style.setProperty('--border-color', '#e9ecef');
      adminPanel.style.setProperty('--shadow-color', 'rgba(0, 0, 0, 0.1)');
      adminPanel.style.setProperty('--header-bg', 'linear-gradient(135deg, #263159 0%, #1a2332 100%)');
      adminPanel.style.setProperty('--button-bg', '#007bff');
      adminPanel.style.setProperty('--button-hover', '#0056b3');
      adminPanel.style.setProperty('--success-color', '#28a745');
      adminPanel.style.setProperty('--warning-color', '#ffc107');
      adminPanel.style.setProperty('--danger-color', '#dc3545');
      adminPanel.style.setProperty('--info-color', '#17a2b8');
      adminPanel.classList.remove('dark-mode');

      // إعادة الألوان الأصلية للعناصر المحددة
      const elements = adminPanel.querySelectorAll('*');
      elements.forEach(element => {
        const style = element.style;
        
        // إعادة البطاقات
        if (style.background === '#333333') {
          style.background = '#ffffff';
        }
        
        // إعادة النصوص
        if (style.color === '#ffffff') {
          style.color = '#263159';
        }
        
        if (style.color === '#cccccc') {
          style.color = '#495057';
        }
        
        // إعادة الحدود
        if (style.border && style.border.includes('#444444')) {
          style.border = style.border.replace(/#444444/g, '#e9ecef');
        }
        
        // إعادة الظلال
        if (style.boxShadow && style.boxShadow.includes('rgba(0, 0, 0, 0.3)')) {
          style.boxShadow = style.boxShadow.replace('rgba(0, 0, 0, 0.3)', 'rgba(0,0,0,0.1)');
        }
      });
    }
  };

  const toggleDarkMode = async () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);
    applyDarkMode(newDarkMode);
    
    try {
      await set(ref(db, 'darkMode'), newDarkMode);
    } catch (error) {
      console.error('خطأ في حفظ حالة الوضع الليلي:', error);
    }
  };

  // إظهار الزر فقط في لوحة التحكم
  const isAdminPanel = window.location.pathname === '/admin';
  if (!isAdminPanel) return null;

  return (
    <button
      onClick={toggleDarkMode}
      style={{
        position: 'fixed',
        top: '20px',
        left: '20px',
        zIndex: 1000,
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: '50%',
        width: '50px',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontSize: '20px',
        color: 'var(--text-primary)',
        boxShadow: '0 2px 10px var(--shadow-color)',
        transition: 'all 0.3s ease',
        backdropFilter: 'blur(10px)'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'scale(1.1)';
        e.target.style.boxShadow = '0 4px 20px var(--shadow-color)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = '0 2px 10px var(--shadow-color)';
      }}
      title={isDarkMode ? 'تفعيل الوضع النهاري' : 'تفعيل الوضع الليلي'}
    >
      {isDarkMode ? '☀️' : '🌙'}
    </button>
  );
} 